/* global rp$, window, document */

require('core-js/fn/array/from');

const inputSuggestions = require('public/js/components/input-suggestions');

/**
 * Find a per-search-bar `<template class="auto-suggest-header-template">` and return a
 * fresh clone of its content, scoped to the given input's component instance.
 *
 * Any feature can opt into rendering content above the auto-suggest list by
 * authoring a single `<template class="auto-suggest-header-template">…</template>`
 * inside its `.search-bar-component`; the first element child of that template
 * is what gets pinned above the suggestion list. Returns `null` when no
 * template is present or the template has no element child.
 *
 * @param {HTMLInputElement} inputEl
 * @returns {HTMLElement|null}
 */
function buildPersistentHeader(inputEl) {
	const scope = inputEl.closest('.search-bar-component');
	if (!scope) {
		return null;
	}
	const tpl = scope.querySelector('.auto-suggest-header-template');
	const firstChild = tpl?.content?.firstElementChild;
	if (!firstChild) {
		return null;
	}
	return firstChild.cloneNode(true);
}

const THE_SCRIPT = function() {
	const $onReady = require('public/js/lib/on-ready');

	$onReady({
		rp$,
		window,
		label: 'auto_suggest',
		fn: function() {
			// For each search input on the page, initialize search suggestions for that input
			const searchInputs = Array.from(document.querySelectorAll('.main-search-wrapper input'));
			searchInputs.forEach(function(inputEl) {
				const persistentHeaderEl = buildPersistentHeader(inputEl);
				inputSuggestions.initialize(inputEl, { persistentHeaderEl });
			});
		},
	});
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
